import React from "react";
import CameraButton from "./CameraButton";
import LeaveRoomButton from "./LeaveRoomButton";
import MicButton from "./MicButton";
import SwitchToScreenSharingButton from "./SwitchToScreenSharingButton";
import RecordMeeting from "./RecordMeeting";
import OpenChatButton from "./OpenChatButton";

const VideoButtons = ({
  connectOnlyWithAudio,
  meetingStream,
  roomId,
  isRoomHost,
  onOpenChat,
  messageCount, // New prop for incoming messages
}) => {
  return (
    <div className="video_buttons_container">
      <MicButton />
      {!connectOnlyWithAudio && <CameraButton />}
      <LeaveRoomButton />
      {!connectOnlyWithAudio && <SwitchToScreenSharingButton />}
      {meetingStream && isRoomHost && (
        <RecordMeeting roomId={roomId} remoteStreams={meetingStream} />
      )}
      <OpenChatButton onClick={onOpenChat} messageCount={messageCount} />
    </div>
  );
};

export default VideoButtons;
